import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import DailyManagementPage from './DailyManagementPage'
type DailyManagementRootProps = {
  match: any
}

const DailyManagementRoot = ({ match }: DailyManagementRootProps) => (
  <Switch>
    <Route path={`${match.path}/:date`} component={DailyManagementPage} />
    <Route exact path={`${match.path}/`} component={DailyManagementPage} />
  </Switch>
)

export default withRouter(DailyManagementRoot)
